import pixels from "~/mixins/third_party/loader/pixels"
import intercom from "~/mixins/third_party/loader/intercom"
import hotjar from "~/mixins/third_party/loader/hotjar"
import analytics from "~/mixins/third_party/loader/analytics"
import amplitude from "~/mixins/third_party/loader/amplitude"
import survicate from "~/mixins/third_party/loader/survicate"
import sentry from "~/mixins/third_party/loader/sentry"

export default [
  pixels,
  hotjar,
  analytics,
  amplitude,
  intercom,
  survicate,
  sentry,
]
